<template>
  <div style="width: 100%" class="d-flex justify-center">
    <div
      class="d-flex align-center"
      style="z-index: 3; position: absolute; bottom: 3rem"
    >
      <span class="pt-1 white--text">Desenvolvido por</span>
      <v-img
        src="../../assets/Eleven_Tickets_Negativo_Horizontal.svg"
        height="100"
        width="170"
        contain
        class="ml-2"
      ></v-img>
    </div>
    <svg
      style="position: absolute; bottom: 0; z-index: 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 320"
    >
      <path
        fill="var(--v-primary-base)"
        fill-opacity="1"
        d="M0,128L30,128C60,128,120,128,180,112C240,96,300,64,360,74.7C420,85,480,139,540,160C600,181,660,171,720,160C780,149,840,139,900,112C960,85,1020,43,1080,32C1140,21,1200,43,1260,64C1320,85,1380,107,1410,117.3L1440,128L1440,320L1410,320C1380,320,1320,320,1260,320C1200,320,1140,320,1080,320C1020,320,960,320,900,320C840,320,780,320,720,320C660,320,600,320,540,320C480,320,420,320,360,320C300,320,240,320,180,320C120,320,60,320,30,320L0,320Z"
      ></path>
    </svg>
    <svg
      style="position: absolute; bottom: 0; z-index: 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 320"
    >
      <path
        fill="var(--v-tertiary-base)"
        fill-opacity="1"
        d="M0,192L40,181.3C80,171,160,149,240,170.7C320,192,400,256,480,256C560,256,640,192,720,144C800,96,880,64,960,96C1040,128,1120,224,1200,240C1280,256,1360,192,1400,160L1440,128L1440,320L1400,320C1360,320,1280,320,1200,320C1120,320,1040,320,960,320C880,320,800,320,720,320C640,320,560,320,480,320C400,320,320,320,240,320C160,320,80,320,40,320L0,320Z"
      ></path>
    </svg>
  </div>
</template>
<script>
export default {
  name: "Waves",
};
</script>
